module.exports = __webpack_public_path__ + "static/media/7f8707a3.jpg";